import { api } from '@/f1/service';
import codes from '@/f1/codes'
import DatePicker from 'vue2-datepicker'
import moment from 'moment-timezone';
import custom from '@/f1/custom';

const default_opt = () => ({
  perPage: 20,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
  created_at_ed : moment().add(1, 'day'),
  created_at_sd : moment().add(-1, 'month'),
});

const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'agent', label: 'From', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'Changed Destination', sortable: false },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'agent', label: 'From', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: '타입', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '시간', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: '행동', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '변경 대상', sortable: false },
  ]
}

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
};

export default {
  components : { DatePicker },
  props: ['is_main'],
  data : () => {
    return {
      custom,
      hash_key : null,
      so : default_opt(),
      selected : '',
      codes,
      limit : 20,
      search_type : '',
      action_type : '',
      model : {}
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    fields() { return i18n_fields[this.i18n]; },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
  },
  methods: {
    // save(item) {
    //   // console.log(item.hash_selected.value);
    //   let snapshot = [[item.target, item.depth, item.hash_selected.value]]
    //   console.log(snapshot)
    //   api.WMDS({target: 'forgery', cmd : 'update', body : { id : item.forgery_id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id }})

    // },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      this.so.perPage = this.limit;
      var search = { target: 'forgery.detect', cmd : 'list',limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } }
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' ? 'asc' : 'desc' }); }
      if(this.so.created_at_ed) { search.body.and.push({ name : 'created_at', value : this.so.created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { search.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }

      // search
      if((this.so.sv || '').trim()) { search.body.and.push({ name : 'code', value : `%${this.so.sv}%`, op : 'like' }) }
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.and.push({"name": key, "value": `%${value}%`, "op": 'like' });
        }
      }
      let and = [];
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.search_type != '') { and.push({ name : "type", value : this.search_type, op : "=" }); }
      if(this.so.skt == 'action') { and.push({ name : "action", value : this.action_type, op : "=" }); }
      if(and.length) { search.body.and = and; }

      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          // case 'action_type' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: value.replace(/\*/g, '%'), op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }
      return api.integrity.Integrity(search).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => console.log(e) );
    },
    async save() {
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is required'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is required.'); }
      try {
        await api.wmds.WMDS('forgery', this.model.id ? 'update' : 'insert', this.model)
        this.$toastr.s(this.i18n_data['saved'][this.i18n]); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) ; }
    },
    async detail(model) {
      this.model = model;
    	console.log('result.vue', 'load item', this.model.id);
      try {
        let rs = await api.wmds.WMDS_Call('forgery.detect', 'detail', { id : this.model.id });
        if(rs.error) {
          this.$toastr.e("load failed", rs.reason)
          return;
        }
        this.model = rs.body;
        this.$toastr.i("loading", "done")
      } catch(e) { this.catch_msg(e) }

    },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    hideList: function(e) {
      this.show = !e; console.log('site.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created() { console.log('result.vue', 'created'); },
  destroyed() { console.log('result.vue', 'destroyed'); },
  mounted() { console.log('result.vue', 'mounted'); },
}
